// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { CareTeam, CareTeamGetAllResponse } from '@quromedical/models';
import { first } from '@quromedical/utils';
import { Col, Row } from 'components/base';
import { DisplayView } from 'components/fhir';
import type { ColumnType } from 'components/table';
import { Text } from 'design-system';
import { strings } from 'strings';

export type CareTeamTable = Partial<CareTeam>;

export const columns: ColumnType<CareTeamTable>[] = [
  {
    header: strings.CareTeamTableNameSubheading,
    Cell: ({ value }) => <Text>{value}</Text>,
    accessor: 'name',
  } as ColumnType<CareTeamTable, 'name'>,

  {
    header: strings.CareTeamStatus,
    Cell: ({ value }) => <Text>{value}</Text>,
    accessor: 'status',
  } as ColumnType<CareTeamTable, 'status'>,

  {
    header: strings.FormLabelMembers,
    Cell: ({ value = [] }) => (
      <Col>
        {value.map((p) => (
          <Row key={p.id}>{<DisplayView reference={p.member} /> || ''}</Row>
        ))}
      </Col>
    ),
    accessor: 'teamMembers',
  } as ColumnType<CareTeamTable, 'teamMembers'>,
  {
    header: strings.CareTeamTableOrganizationSubheading,
    Cell: ({ value }) => <DisplayView reference={first(value)} />,
    accessor: 'managingOrganization',
  } as ColumnType<CareTeamTable, 'managingOrganization'>,
];

export const getCareTeamDataFromResponse = (
  res: CareTeamGetAllResponse,
): CareTeamTable[] => {
  return res.careTeams.map<CareTeamTable>((careTeam) => {
    const teamMembers = first(careTeam.teamMembers);

    return {
      ...careTeam,
      role: first(teamMembers?.role)?.text,
      member: teamMembers?.member.display,
      start: careTeam.period?.start,
    };
  });
};
